import React from 'react';
import { Button } from '@lt/components';
import { NoFilterHotelResults } from '@lt/components/icons-react/userflow';

import { useTranslation } from '@lt/localization';

import classnames from 'classnames';
import {
  formatDateToDayWithMonth,
  convertClientDateToServerDate,
} from '../../../../utils/dateUtils';
import type { SearcherFilteredEmptyProps } from './types';

import styles from './searcher.module.css';

const SearcherFilteredEmpty = ({
  isMobile,
  date,
  onClick,
  isHotelOnly,
}: SearcherFilteredEmptyProps) => {
  const parseDate = convertClientDateToServerDate(date);
  const dateText = formatDateToDayWithMonth(parseDate);
  const { t } = useTranslation();

  return (
    <div
      className={classnames(styles.searcherFilteredEmptyContainer, {
        [styles.searcherFilteredEmptyContainerMobile]: isMobile,
      })}
    >
      <NoFilterHotelResults className={styles.noFilterHotelResults} />
      <div
        className={classnames(styles.searcherFilteredEmptyHeader, {
          [styles.searcherFilteredEmptyHeaderMobile]: isMobile,
        })}
      >
        {t('hotel.filteredEmpty.title', {
          context: isHotelOnly ? 'hotel' : 'package',
        })}
        {dateText}
      </div>
      {!isHotelOnly ? (
        <div
          className={classnames(styles.searcherFilteredEmptyText, {
            [styles.searcherFilteredEmptyTextMobile]: isMobile,
          })}
        >
          {t('hotel.filteredEmpty.subtitle')}
        </div>
      ) : null}
      <Button className={styles.searcherFilteredEmptyButton} onClick={onClick}>
        {t('filters.clearbutton.desktop')}
      </Button>
    </div>
  );
};

export default SearcherFilteredEmpty;
